import * as React from 'react';
import { cn } from '../../../utils';

export interface InterludeQuoteProps {
  /** centered serif italic quote */
  quote: React.ReactNode;
  /** red uppercase attribution, e.g. "— Maya Angelou · the voice of Unit 3" */
  attribution?: React.ReactNode;
  /** accessible name for the <aside> landmark */
  ariaLabel?: string;
  className?: string;
}

/**
 * Full-width baby-pink interlude band with a centered serif italic quote
 * and a red uppercase attribution line.
 */
export function InterludeQuote({ quote, attribution, ariaLabel, className }: InterludeQuoteProps) {
  return (
    <aside className={cn('z-interlude', className)} aria-label={ariaLabel}>
      <div className="z-page">
        <p className="z-q">{quote}</p>
        {attribution != null && <p className="z-who">{attribution}</p>}
      </div>
    </aside>
  );
}
